import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const SelectPolicy = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedCert, setSelectedCert] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const accessToken = localStorage.getItem("accessToken");
    setLoading(true);
    setError("");

    axios
      .get("/api/actionables/policies/", {
        headers: accessToken
          ? { Authorization: `Bearer ${accessToken}` }
          : undefined,
      })
      .then((res) => setData(res.data || []))
      .catch((err) => {
        console.error("Error fetching grouped policies:", err);
        setError(
          err.response?.data?.detail ||
            err.response?.data?.error ||
            "Failed to load policies."
        );
      })
      .finally(() => setLoading(false));
  }, []);

  const handleChoose = (policyName, certification) => {
    const params = new URLSearchParams();
    if (policyName) params.set("policy", policyName);
    if (certification) params.set("certification", certification);
    navigate(`/actionables-glance?${params.toString()}`);
  };

  const selectedGroup = data.find((group) => group.certification === selectedCert);

  return (
    <div className="page-shell">
      <section className="compact-hero">
        <div className="header-row" style={{ marginBottom: 0 }}>
          <div>
            <h1>Select Policy</h1>
            <p>
              Start from a certification, then jump directly into the actionable
              view for the policy or document you want to monitor.
            </p>
          </div>
          <button className="secondary-btn" onClick={() => navigate("/dashboard")}>
            Back
          </button>
        </div>
      </section>

      {loading ? (
        <div className="card loading">Loading policies...</div>
      ) : error ? (
        <p className="error-text" style={{ padding: "14px 16px" }}>
          {error}
        </p>
      ) : data.length === 0 ? (
        <div className="card">No policies found for your user.</div>
      ) : (
        <>
          <section className="card">
            <div className="filter-item" style={{ maxWidth: "420px" }}>
              <label className="dropdownLabel">Certification</label>
              <select value={selectedCert} onChange={(e) => setSelectedCert(e.target.value)}>
                <option value="">Choose certification</option>
                {data.map((group, idx) => (
                  <option key={idx} value={group.certification}>
                    {group.certification}
                  </option>
                ))}
              </select>
            </div>
          </section>

          {selectedCert && (
            <section className="card">
              <div className="header-row">
                <div>
                  <h2 style={{ margin: 0, color: "#102a71" }}>{selectedCert}</h2>
                  <p style={{ margin: "8px 0 0", color: "#65748f" }}>
                    Choose a policy to open its actionable summary.
                  </p>
                </div>
                <div className="pill">
                  {selectedGroup?.policies?.length || 0} policies
                </div>
              </div>

              <div className="policyGrid" style={{ gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))" }}>
                {selectedGroup?.policies?.map((policy, index) => (
                  <button
                    key={index}
                    type="button"
                    className="surface-card"
                    onClick={() =>
                      handleChoose(policy.policy_or_document_name, selectedCert)
                    }
                    style={{
                      padding: "1.2rem",
                      textAlign: "left",
                      border: "1px solid rgba(16,42,113,0.08)",
                    }}
                  >
                    <div style={{ fontWeight: 800, fontSize: "1rem", color: "#10203d" }}>
                      {policy.policy_or_document_name}
                    </div>
                    <div style={{ marginTop: "10px", color: "#2053c3", fontWeight: 700 }}>
                      {policy.count} actionables
                    </div>
                  </button>
                ))}
              </div>
            </section>
          )}
        </>
      )}
    </div>
  );
};

export default SelectPolicy;
